import React, { useState, useEffect, useRef, useCallback } from 'react';

const CountUp = ({ value, duration = 2000 }) => {
  const [displayValue, setDisplayValue] = useState(value);
  const ref = useRef(null);
  const hasAnimated = useRef(false);

  const startCounting = useCallback(() => {
    const match = value.match(/(\d+)(.*)/);
    if (!match) {
      setDisplayValue(value);
      return;
    }
    const targetNum = parseInt(match[1], 10);
    const suffix = match[2];
    let startTime = null;
    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const progress = (currentTime - startTime) / duration;
      const current = Math.min(progress * targetNum, targetNum);
      setDisplayValue(`${Math.floor(current)}${suffix}`);
      if (progress < 1) requestAnimationFrame(animate);
      else setDisplayValue(`${targetNum}${suffix}`);
    };
    requestAnimationFrame(animate);
  }, [value, duration]); // depends on props

  useEffect(() => {
    const node = ref.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          startCounting();
        }
      },
      { threshold: 0.5 }
    );

    if (node) observer.observe(node);

    return () => {
      if (node) observer.unobserve(node);
    };
  }, [startCounting]); // now dependency is safe

  return <span ref={ref}>{displayValue}</span>;
};

export default CountUp;
